import ChantierInfoGraphView from './ChantierInfoGraphView';
import React, {useEffect, useState} from 'react';
import {getTachesGraph} from '../../../services/MadricService';
import {useParams} from 'react-router-dom';

/**
 * Permet de gérer le graphique du chantier
 * @return {JSX}
 */
export default function ChantierInfoGraph() {
  const {id} = useParams();
  const [tacheInfo, setTacheInfo] = useState([]);
  const [waitTimeFetchInfo, setWaitTimeFetchInfo] = useState(false);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    getTacheInfo();
  }, []);

  /**
   * Permet d'allez chercher toutes les informations des tâches
   */
  async function getTacheInfo() {
    const res = await getTachesGraph(id);
    setTacheInfo(res.data);
    const arrayOfIntegers = res.data.sums.map((str) => parseInt(str));
    setTotal(arrayOfIntegers.reduce((acc, curr) => acc + curr, 0));
    setWaitTimeFetchInfo(true);
  }

  return (
    <div>
      {waitTimeFetchInfo === false ? '' : <ChantierInfoGraphView names={tacheInfo.names} colors={tacheInfo.colors} sums={tacheInfo.sums} total={total} sumUser={tacheInfo.sumUser} users={tacheInfo.users}/>}
    </div>
  );
}
